module.exports = __webpack_public_path__ + "static/christmas-carols-bce552e332545b10b4a56ec6326cd2d7.png";